import { useOutdatedStore } from '../../store/outdated'
import './OutdatedOverlay.css'

// Blocking screen rendered when the server has told us this client is
// below its `min` policy (HTTP 426 or WS close 4426). No dismiss path —
// the user must update the app.
//
// Inside the iOS/Android shell the store's app-update prompt is the real
// remediation; in pure browser the user is told to refresh after updating.
//
// Spec: docs/forward-compat-version-handshake.md.
export function OutdatedOverlay() {
  const outdated = useOutdatedStore((s) => s.outdated)
  if (!outdated) return null

  function openUpdate() {
    if (!outdated?.updateURL) return
    window.open(outdated.updateURL, '_blank')
  }

  return (
    <div className="outdated-overlay" role="dialog" aria-modal="true">
      <div className="outdated-overlay__card">
        <h2 className="outdated-overlay__title">Update required</h2>
        <p className="outdated-overlay__body">
          This version of the app is no longer supported by the server.
          Please update to continue.
        </p>
        {(outdated.minVersion || outdated.yourVersion) && (
          <dl className="outdated-overlay__versions">
            {outdated.yourVersion && (
              <>
                <dt>This version</dt>
                <dd>{outdated.yourVersion}</dd>
              </>
            )}
            {outdated.minVersion && (
              <>
                <dt>Minimum supported</dt>
                <dd>{outdated.minVersion}</dd>
              </>
            )}
          </dl>
        )}
        {outdated.updateURL && (
          <button
            type="button"
            className="outdated-overlay__update"
            onClick={openUpdate}
          >
            Open update page
          </button>
        )}
      </div>
    </div>
  )
}
